export const totalProductsSold = {
	label: "Total products sold",
};
